import { api } from '@/services'

export const show = (id) => {
  return api.get(`/admin/itemPrice/show/${id}`)
}

export const edit = (itemPrice) => {
  return api.put('/admin/itemPrice/update', itemPrice)
}

export const create = (itemPrice) => {
  return api.post('/admin/itemPrice/create', itemPrice)
}

export const remove = (id) => {
  return api.delete(`admin/itemPrice/delete/${id}`)
}
